// client/src/components/AdminMenu.js
import React from 'react';
import axios from 'axios';

function AdminMenu() {
  const refreshComboFile = async () => {
    try {
      const res = await axios.post('http://localhost:5000/api/admin/refresh-combo-file');
      alert('갱신 성공: ' + JSON.stringify(res.data));


    } catch (err) {
      alert('갱신 실패: ' + err.message);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h3>관리자 메뉴</h3>
      <button onClick={refreshComboFile}>콤보 데이터 수동 갱신</button>
    </div>
  );
}

export default AdminMenu;
